module.exports = __webpack_public_path__ + "static/img/cop_sch_logo15.d4777a2c.png";